import React, { memo } from "react";
import PropTypes from "prop-types";

import clsx from "clsx";
import upperFirst from "lodash/upperFirst";

import { Tooltip } from "@mui/material";

import { MediaTypeSearchIcon } from "../../../../assets/styles/icons";
import { classes, IconButton } from "../styles/filters";
import { mediaTypesEnum } from "../../../../configurations/appConstants";

const MediaTypeSearch = ({ searchMediaTypes, onSearchMediaTypes }) => {
  return (
    <>
      {mediaTypesEnum.map(mediaType => (
        <Tooltip key={mediaType} title={upperFirst(mediaType)}>
          <IconButton
            name={mediaType}
            id={mediaType}
            className={clsx({
              [classes.active]: searchMediaTypes.includes(mediaType)
            })}
            onClick={onSearchMediaTypes}
          >
            <MediaTypeSearchIcon type={mediaType} />
          </IconButton>
        </Tooltip>
      ))}
    </>
  );
};

MediaTypeSearch.propTypes = {
  searchMediaTypes: PropTypes.array
};

MediaTypeSearch.defaultProps = {
  searchMediaTypes: []
};

export default memo(MediaTypeSearch);
